import { Roles } from 'ducks/merchantDucks/user/types';

export const restrictRelatedAccountForRoles = [Roles.ANALYST];
